import { IconLayoutGrid } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { faNumber } from "./format";
import classes from "./home.module.scss";
import { HomeSection, badgeNouns } from "./sections";

export function SectionTile({ section, count = 0 }: { section: HomeSection; count?: number }) {
  const Icon = section.icon;
  const noun = section.badge ? badgeNouns[section.badge] : "";
  return (
    <Link
      to={section.to}
      onClick={section.onOpen}
      className={classes.tile}
      aria-label={count > 0 ? `${section.label}، ${faNumber(count)} ${noun}` : undefined}
    >
      <span className={`${classes.tileIcon} ${classes.tone}`} data-tone={section.group}>
        <Icon size={26} stroke={1.7} aria-hidden />
        {count > 0 && (
          <span className={classes.badge} aria-hidden>
            {count > 99 ? "۹۹+" : faNumber(count)}
          </span>
        )}
      </span>
      <span className={classes.tileLabel}>{section.label}</span>
    </Link>
  );
}

export function AllSectionsTile() {
  return (
    <Link to="/dashboard/menu" className={classes.tile}>
      <span className={`${classes.tileIcon} ${classes.tone}`} data-tone="all">
        <IconLayoutGrid size={26} stroke={1.7} aria-hidden />
      </span>
      <span className={classes.tileLabel}>همه‌ی بخش‌ها</span>
    </Link>
  );
}
